











import Vue from "vue";
import AppHeader from "./components/AppHeader.vue";
import AppFooter from "./components/AppFooter.vue";

export default Vue.extend({
  components: {
    AppHeader,
    AppFooter,
  },

  methods: {
    hideSlideMenu(event: Event): void {
      if (event.target) {
        const eventElement = event.target as HTMLElement;
        if (
          !eventElement.closest("#menuIconWrapper") &&
          !eventElement.closest("#slideNavigation")
        ) {
          this.$store.state.slideMenuOpen = false;
        }
      }
    },
  },
});
